import React from 'react';


// UI
import { Typography } from '@cube3/cubicle/src/core/atoms/Typography';

import { Toggle } from '@cube3/cubicle/src/core/atoms/Toggle/Toggle'
import { Free, HBox, Item, VBox } from '@cube3/cubicle/src/core/templates/layout/Flex';

interface Props {
  isPublic: boolean;
  setIsPublic(val: boolean): void;
  workspaceName: string;
  multiple?: boolean;
}

export const ProjectVisibilitySwitch = (props: Props) => {

  const { isPublic, setIsPublic, workspaceName, multiple = false } = props;

  return <HBox style={{ marginBottom: '20px' }} gap={16} align='center'>

    <Free>
      <VBox gap={4}>
        <Typography variant="lg" >
          {`Let Project${multiple ? 's' : ''} be visible to all ${workspaceName} Workspace Members`}
        </Typography>
        <Typography variant="md" colorVariant='02'>
          {`They will be able to view and download ${multiple ? 'these  Projects\'' : 'this  Project\'s'} contents.`}
        </Typography>
      </VBox>
    </Free>
    <Item data-pw={'project-visibility-toggle'}>
      <Toggle value={isPublic} onChange={(val) => setIsPublic(val)} />
    </Item>
  </HBox>
}